export enum EBusinessIndustrySectorAppetite {
    GROWTH = 'GROWTH',
    NEUTRAL = 'NEUTRAL',
    CAUTIOUS = 'CAUTIOUS',
    FORBIDDEN = 'FORBIDDEN',
    NA = 'NA',
}
export const BusinessIndustrySectorAppetite = {
    [EBusinessIndustrySectorAppetite.GROWTH]: 'Growth',
    [EBusinessIndustrySectorAppetite.NEUTRAL]: 'Neutral',
    [EBusinessIndustrySectorAppetite.CAUTIOUS]: 'Cautious',
    [EBusinessIndustrySectorAppetite.FORBIDDEN]: 'Forbidden',
    [EBusinessIndustrySectorAppetite.NA]: 'N/A',
};
export type BUSINESS_INDUSTRY_SECTOR_APPETITE = keyof typeof EBusinessIndustrySectorAppetite;

export enum EBusinessIndustrySegment {
    CONSTRUCTION = 'CONSTRUCTION',
    F_AND_B = 'F_AND_B',
    HOSPITALITY = 'HOSPITALITY',
    MANUFACTURING = 'MANUFACTURING',
    RETAIL = 'RETAIL',
    SERVICES = 'SERVICES',
    TRANSPORT_STORAGE = 'TRANSPORT_STORAGE',
    WHOLESALE = 'WHOLESALE',
}
export const BusinessIndustrySegment = {
    [EBusinessIndustrySegment.CONSTRUCTION]: 'Construction',
    [EBusinessIndustrySegment.F_AND_B]: 'F&B',
    [EBusinessIndustrySegment.HOSPITALITY]: 'Hospitality',
    [EBusinessIndustrySegment.MANUFACTURING]: 'Manufacturing',
    [EBusinessIndustrySegment.RETAIL]: 'Retail',
    [EBusinessIndustrySegment.SERVICES]: 'Services',
    [EBusinessIndustrySegment.TRANSPORT_STORAGE]: 'Transport/ Storage',
    [EBusinessIndustrySegment.WHOLESALE]: 'Wholesale',
};
export type BUSINESS_INDUSTRY_SEGMENT = keyof typeof EBusinessIndustrySegment;
